<template>
  <div class="public-event-history-gallery" v-if="images && images.length">
    <div v-if="title" class="title">
      <label class="md-alignment-center">
        {{ title }}
      </label>
    </div>
    <swiper
      class="swiper"
      :options="swiperOption"
      :lazy="true"
      responsive
      :style="!displayArrows ? 'text-align: -webkit-center' : ''"
    >
      <swiper-slide v-for="(item, index) in images" :key="index">
        <img
          class="event-gallery-img"
          :src="mixinGetFilePath(item.src, 'M')"
          @click="openLightBoxGallery(index)"
        />
      </swiper-slide>
      <div
        v-if="displayArrows"
        class="swiper-button-prev swiper-button-black"
        slot="button-prev"
      ></div>
      <div
        v-if="displayArrows"
        class="swiper-button-next swiper-button-black"
        slot="button-next"
      ></div>
    </swiper>
    <light-box
      v-if="media && media.length"
      ref="lightbox"
      :media="media"
      :show-light-box="false"
      :show-caption="true"
      :show-thumbs="false"
      :site-loading="siteLoading"
      :disable-zoom="false"
    ></light-box>
  </div>
</template>

<script>
import settings from '@/settings';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import LightBox from 'vue-image-lightbox';
require('vue-image-lightbox/dist/vue-image-lightbox.min.css');

export default {
  components: {
    swiper,
    swiperSlide,
    LightBox,
  },
  data() {
    return {
      settings: settings,
      swiperOption: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 3,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      // fakeData: [
      //   {
      //     src:
      //       'https://storage.googleapis.com/rfider-dev-file-uploads/local-environment/fixtures/thing/gallery1.jpg',
      //   },
      //   {
      //     src: 'local-environment/portal/org_4/Beverage-copy-1dkse76vd3.png',
      //   },
      //   {
      //     src: 'local-environment/portal/org_4/Beverage-copy-1dkse76vd3.png',
      //   },
      //   {
      //     src:
      //       'https://storage.googleapis.com/rfider-dev-file-uploads/local-environment/fixtures/thing/gallery4.jpg',
      //   },
      // ],
      siteLoading: require('../../../public/img/spinner.gif'),
    };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
  },
  computed: {
    images() {
      let result = [];
      if (this.items) {
        this.items.forEach((item) => {
          if (
            item.showEventGallery &&
            Array.isArray(item.tags) &&
            item.tags.includes('eventGallery')
          ) {
            const taskName = item.taskName;
            const location = this.extractInteractionLocation(item);

            // Extracting interaction images
            result = result.concat(
              this.extractAttachmentsImages(item, taskName, location),
            );

            // Extracting interaction steps's images
            if (Array.isArray(item.steps)) {
              item.steps.forEach((step) => {
                result = result.concat(
                  this.extractAttachmentsImages(step, taskName, location),
                );
              });
            }
          }
        });
      }

      // result = result.concat(this.fakeData);
      return result;
    },
    displayArrows() {
      return !!(this.images.length > 6);
    },
    media() {
      let media = [];
      media = this.images.map((image) => {
        return {
          // thumb: this.mixinGetFilePath(image.src, 'S'),
          src: this.mixinGetFilePath(image.src, 'O'),
          caption: `<html> <p>${image.taskName}</p> <span>${image.location}<br />${image.date}</span>`,
        };
      });
      return media;
    },
  },
  methods: {
    extractAttachmentsImages(object, taskName, location) {
      let images = [];
      const captionDate = object._id ? object.createdAt : object.startedAt;
      if (object.metadata && Array.isArray(object.metadata.attachments)) {
        object.metadata.attachments.forEach((attachment) => {
          if (this.mixinGetImageRegex().test(attachment.file)) {
            images.push({
              src: attachment.file,
              taskName: taskName,
              date: this.displayTimeZone(captionDate, 'DD/MM/YYYY [at] h:mm A'),
              location: location,
            });
          }
        });
      }
      return images;
    },
    extractInteractionLocation(interaction) {
      let finalLocation = 'Unknown Location';

      try {
        const { components } = interaction.metadata.location.details || {};
        const location = !components
          ? []
          : components
              .filter((element) => {
                return element.types.includes('political');
              })
              .slice(-2);

        if (location.length > 0) {
          let city = location[0] ? location[0].long_name : null;
          let country = location[1] ? location[1].long_name : null;
          if (city) {
            finalLocation = city;
            if (country) {
              finalLocation = `${city}, ${country}`;
            }
          }
        }
      } catch (e) {
        console.log(e);
        finalLocation = 'Unknown Location';
      }

      return finalLocation;
    },
    openLightBoxGallery(index) {
      this.$refs.lightbox.showImage(index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-event-history-gallery.scss';
</style>
